export const newableTwilsockClientRTTI = Symbol.for("NewableTwilsockClient");
export const productIdRTTI = Symbol.for("ProductID");
export const twilsockRTTI = Symbol.for("Twilsock");
